import { render, staticRenderFns } from "./TrendManagementHelp.vue?vue&type=template&id=25af3711&scoped=true"
import script from "./TrendManagementHelp.vue?vue&type=script&lang=js"
export * from "./TrendManagementHelp.vue?vue&type=script&lang=js"
import style0 from "./TrendManagementHelp.vue?vue&type=style&index=0&id=25af3711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af3711",
  null
  
)

export default component.exports